import plan from "./plan.jpg.asset.json";

const photoModules = import.meta.glob("./img-*.jpg.asset.json", {
  eager: true,
  import: "default",
}) as Record<string, { url: string }>;

export const zlicinBytImages = Object.entries(photoModules)
  .sort(([a], [b]) => a.localeCompare(b))
  .map(([, asset]) => asset.url);

export const zlicinBytFloorPlans = [{ image: plan.url, label: "Půdorys bytu – 3D" }];
